import React, { PropsWithChildren } from "react";

const HighlightedText = ({ children }: PropsWithChildren) => {
  return (
    <p className="relative z-20 -ml-1 inline-flex px-1.5 py-0.5">
      {children}
      <span
        className="bg-lightYellow absolute inset-x-0 bottom-0.5 -z-10 h-6 w-full md:h-8"
        aria-hidden="true"
      ></span>
    </p>
  );
};

export default HighlightedText;
